export default function validateLogin(values) {
  let errors = {};

  // Email Error
  if(!values.email){
    errors.email = "Email erforderlich"
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)){
    errors.email = "Ungültige Email Adresse"
  }

  // Password Errors
  if(!values.password){
    errors.password = "Passwort erforderlich"
  }else if(values.password.length < 6){
    errors.password = "Passwort muss mindestens 6 Zeichen enthalten"
  }

  return errors;

}
